module.exports = __webpack_public_path__ + "static/img/12.5813020.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/4/eng/12.png
// module id = ysRt
// module chunks = 0